export default __webpack_public_path__ + "style-osm-500-3d80172f5c2df4d6c8fa5b0fe7465037.webp";